module.exports = __webpack_public_path__ + "img/Movile-up.f21ca979.jpg";